import React, { useState } from "react";
import { Grid, Stack, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { countries } from "country-data";
import StarIcon from "@mui/icons-material/Star";

const UserBids = ({ bid, clickHandler }) => {
  return (
    <Grid
      container
      style={{
        borderBottom: "1px solid #EEEBEF",
        marginTop: "20px",
        paddingBottom: "20px",
        cursor: "pointer",
      }}
      // alignItems="center"
      onClick={() => clickHandler(bid._id)}
    >
      <Grid item sm={1}></Grid>
      <Grid item sm={2}>
        <AccountCircleIcon
          style={{ height: "80px", width: "80px", color: "#EEEBEF" }}
        />
      </Grid>
      <Grid item sm={8}>
        <Stack direction="row" spacing={1} alignItems="center" className="mb-5">
          <Typography style={{ fontWeight: "bold" }}>
            {bid.serviceProviderName}
          </Typography>
          <CheckCircleIcon
            style={{ height: "15px", width: "15px", color: "#FA8319" }}
          />
        </Stack>

        <Typography
          className="mb-5"
          style={{ color: "rgba(122, 122, 128, 1)" }}
        >
          {countries[bid.serviceProviderCountry].name}
        </Typography>
        <Stack
          style={{
            padding: "3px",
            borderRadius: "4px",
            backgroundColor: "rgba(52, 168, 83, 0.3)",
            width: "10%",
          }}
          spacing={1}
          direction="row"
          alignItems="center"
          className="mb-5"
        >
          <StarIcon
            style={{
              height: "18px",
              width: "18px",
              color: "rgba(52, 168, 83, 1)",
            }}
          />
          <Typography style={{ color: "rgba(52, 168, 83, 1)" }}>4.0</Typography>
        </Stack>
        <Typography className="mb-5" style={{ fontWeight: "bold" }}>
          £{bid.price}
        </Typography>
        <Typography
          className="mb-5"
          style={{ color: "rgba(122, 122, 128, 1)" }}
        >
          {bid.offerDetails}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default UserBids;
